import { render, staticRenderFns } from "./groupEditView.vue?vue&type=template&id=880024c0&scoped=true&"
import script from "./groupEditView.vue?vue&type=script&lang=js&"
export * from "./groupEditView.vue?vue&type=script&lang=js&"
import style0 from "./groupEditView.vue?vue&type=style&index=0&id=880024c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880024c0",
  null
  
)

export default component.exports